import { render, staticRenderFns } from "./VAssetsDetails.vue?vue&type=template&id=143bb663&"
import script from "./VAssetsDetails.vue?vue&type=script&lang=js&"
export * from "./VAssetsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports